<form class="form logup-form" [formGroup]="logupForm" (submit)="onSubmit()">
  <div class="form-header">
    <h4>Logup</h4>
    <p>Complete to create your user</p>
  </div>
  <app-form-input
    placeholder="Name"
    [fieldControl]="logupForm.get('name')"
    fieldControlName="name"
    regex="(?!.*\s{2})^[a-zA-ZÀ-úñÑ\s]+$"></app-form-input>
  <app-form-input
    placeholder="Username"
    [fieldControl]="logupForm.get('username')"
    fieldControlName="username"
    regex="^[a-zA-Z0-9_]*$"></app-form-input>
  <app-form-input
    type="email"
    placeholder="Email"
    [fieldControl]="logupForm.get('email')"
    fieldControlName="email"></app-form-input>
  <app-form-input
    type="password"
    placeholder="Password"
    [fieldControl]="logupForm.get('password')"
    fieldControlName="password"></app-form-input>
  <button class="btn btn-primary" [disabled]="logupForm.invalid && !backError">
    <span class="spinner-border spinner-border-sm" *ngIf="loading; else btnText"></span>
    <ng-template #btnText>Submit</ng-template>    
  </button>
  <a routerLink="/login">Already registered?</a>
</form>